import { useQuery } from "@tanstack/react-query";
import { axios } from "../../../shared/lib/axios";

export const getStudentTasks = async (enrollmentId, courseId, studentId) => {
  const res = await axios.middleware(
    "/Backend.asmx/BK_TarefasAlunoDisciplina",
    {
      params: {
        matriculaid: enrollmentId,
        disciplinaid: courseId,
        alunoid: studentId,
      },
    }
  );
  
  return res[0].data;
};

export const useStudentTasks = ({
  config,
  enrollmentId,
  courseId,
  studentId,
} = {}) => {
  return useQuery({
    ...config,
    queryKey: ["studentTasks", { enrollmentId, courseId, studentId }],
    queryFn: () => getStudentTasks(enrollmentId, courseId, studentId),
  });
};
